import { render, staticRenderFns } from "./ImageGalleryDialog.vue?vue&type=template&id=4cda550c"
import script from "./ImageGalleryDialog.vue?vue&type=script&lang=js"
export * from "./ImageGalleryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports